import {Component, EventEmitter, OnChanges, OnInit, Output, AfterViewInit, Input} from '@angular/core';
import {trigger, style, animate, transition,keyframes} from '@angular/animations';
import {ApiService} from "../api.service";
import {CommonService} from '../common.service';

declare var polyvPlayer :any;

@Component({
  selector: 'app-case-practice-authorization-video',
  animations: [
    trigger('videoAnimation', [
			transition(':enter', [
         style({opacity: 0}),
         animate('1s ease-out', style({opacity: 1}))
      ]),
	    transition(':leave', animate('500ms', keyframes([
	      style({opacity: 1, transform: 'scale(1, 1)'}),
	      style({opacity: 0, transform: 'scale(0, 0)'})
	    ]))),
    ])
  ],
  templateUrl: './case-practice-authorization-video.component.html',
  styleUrls: ['./case-practice-authorization-video.component.css']
})


export class CasePracticeAuthorizationVideoComponent implements OnInit, AfterViewInit  {
  @Input() isPC: boolean;
  @Input() practiceMetaId: any;
  @Input() exerciseMetaId:number;
  @Output() onGoToNextStep = new EventEmitter<any>();
  showVideo:Boolean = true;
  assetsRoute: string = "../../assets";
  constructor(private apiService: ApiService,private commonService:CommonService) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    let _this = this;
		_this.showVideo = true;
    window['s2j_onPlayOver'] = function () {
			_this.showVideo = false;
    	setTimeout(function(){
    		_this.onGoToNextStep.emit(2);
    		_this.commonService.setOnceIno(_this.commonService.getOnceValue(_this.exerciseMetaId,701)).subscribe();
			},300)
    };

  }

  ngAfterViewInit(){

    var player = polyvPlayer({
      wrap: '#video-auth',
      width: '100%',
      height: this.isPC ? '100vh' : window.screen.width/9*16,
      vid: '352e2664d87bd3406306f195c9115e98_3',
      // autoplay: true,
      // skinLocation: 0,
      ban_history_time: 'on',
      // hideSwitchPlayer: true,
      hideRepeat: true,
      forceH5: true,
      flashvars: {'autoplay': true}
      // audioMode: false
    });

    if(!this.isPC){
      player.toggleFullscreen();
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-video/case-practice-authorization-video.component.ts